import { z } from "zod";
export const EventStatusSchema = z.enum(["draft", "live", "paused", "ended"]);
export const EventSchema = z.object({
    id: z.string().uuid(),
    owner_id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    status: EventStatusSchema,
    join_code: z.string(),
    qr_code: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    start_time: z.string().nullable(),
    end_time: z.string().nullable(),
});
export const PublicEventSchema = EventSchema.omit({ owner_id: true });
